import { jsx, jsxs } from "react/jsx-runtime";
import { Collapse } from "@perxis-auto/ui-kit/lib/components/Collapse";
import { Divider } from "@perxis-auto/ui-kit/lib/components/Divider";
import { Row, Col } from "@perxis-auto/ui-kit/lib/components/Grid";
import { Table } from "@perxis-auto/ui-kit/lib/components/Table";
import { Typography } from "@perxis-auto/ui-kit/lib/components/Typography";
import styles from "./EquipmentItem.module.scss.js";
function EquipmentItem({ groups, activeGroups, onActiveGroupChange }) {
  var _a;
  const isHidden = !groups.length;
  const isShowCollapse = groups.length > 1;
  const renderTable = (items) => {
    return /* @__PURE__ */ jsx(Table, { xs: 24, lg: 12, gutter: [{ xs: 0, sm: 0, md: 0, lg: 32, xl: 36, xxl: 42 }, 0], itemKey: "key", items, children: ({ label, value }) => /* @__PURE__ */ jsxs(Row, { align: "middle", gutter: 5, children: [
      /* @__PURE__ */ jsx(Col, { span: value ? 12 : 24, className: styles.equipmentItem__itemLabel, children: /* @__PURE__ */ jsx(Typography.Text, { color: "dark-light", children: label }) }),
      !!value && /* @__PURE__ */ jsx(Col, { span: 12, className: styles.equipmentItem__itemValue, children: /* @__PURE__ */ jsx(Typography.Text, { level: "main", color: "darkest", children: /* @__PURE__ */ jsx("strong", { children: value }) }) })
    ] }) });
  };
  const defaultActiveGroups = (activeGroups == null ? void 0 : activeGroups.length) ? activeGroups : (_a = groups[0]) == null ? void 0 : _a.id;
  if (isHidden) {
    return null;
  }
  return /* @__PURE__ */ jsx(Row, { gutter: [0, "vertical-yellow"], className: styles.equipmentItem, children: /* @__PURE__ */ jsxs(Col, { span: 24, children: [
    /* @__PURE__ */ jsx(Divider, { width: "thick", color: "dark", curved: true }),
    isShowCollapse ? /* @__PURE__ */ jsx(
      Collapse,
      {
        items: groups.map(({ id, title, items }) => ({
          key: id,
          label: title,
          children: renderTable(items)
        })),
        defaultActiveKey: defaultActiveGroups,
        onChange: (key) => {
          onActiveGroupChange == null ? void 0 : onActiveGroupChange(Array.isArray(key) ? key : [key]);
        }
      }
    ) : /* @__PURE__ */ jsx("div", { className: styles.equipmentItem__singleTable, children: renderTable(groups[0].items) })
  ] }) });
}
export {
  EquipmentItem
};
